import React, { useRef, useState } from "react";

import { IgButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import Editor from "@monaco-editor/react";
import { Box, Grid } from "@mui/material";

import { usePatchConfigurations } from "../../api/configurations/patch-configurations";
import { useConfiguration } from "../../api/configurations/use-configuration";

export const CssSettings = () => {
  const mutateConfigurations = usePatchConfigurations();
  const cssSettings = useConfiguration("css");

  const [cssData, setCssData] = useState<string>(cssSettings?.value || "");
  const editorRef = useRef(null);

  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
  }

  const onCurrencyFormatSave = () => {
    mutateConfigurations.mutate([
      {
        ...cssSettings,
        value: cssData,
      },
    ]);
  };

  return (
    <Grid item>
      <IgPaper>
        <Grid container direction={"column"} rowSpacing={1}>
          <Grid item>
            <IgTypography variant="h6">Global CSS Styles</IgTypography>
          </Grid>
          <Grid item>
            <IgTypography>
              Inject custom CSS styles on your site. These styles will always be
              applied while Intelligems is installed.
            </IgTypography>
          </Grid>
          <Grid
            container
            item
            direction={"row"}
            sx={{
              alignItems: "center",
              flexWrap: "nowrap",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <Grid container item direction={"column"} rowSpacing={1}>
              <Box
                sx={{
                  border: "solid 1px #CBCBCB",
                  marginRight: "10px",
                }}
              >
                <Editor
                  height="300px"
                  defaultLanguage="css"
                  defaultValue={cssData}
                  onMount={handleEditorDidMount}
                  onChange={(e) => {
                    setCssData(e || "");
                  }}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid item mt={2}>
            <IgButton
              loading={mutateConfigurations.isPending}
              onClick={onCurrencyFormatSave}
              variant={"contained"}
            >
              Save
            </IgButton>
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
